var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"content"},[_c('section',[_c('h1',[_vm._v("Список тегов")]),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.tags),function(tag){return _c('nuxt-link',{key:`tag-${tag.id}`,staticClass:"item",attrs:{"to":`/tag/${tag.id}-${tag.name}`}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }